import React,{useRef, useState, useEffect} from "react";
import { Form, Col, Row, Button} from "react-bootstrap";
import Select from "react-select";
import EditableRange from "../components/EditableRange";
import atlasApi from "../utils/atlasapi";
import { X, Trash, Angle, Subtract} from "@phosphor-icons/react";
import ColorPicker			from "../components/ColorPicker";
import LayerDrawing			from "../classes/LayerDrawing";




export default function DrawingPanel({
	setup,
	handler,
	onClose,
	onChange,
	onSaveClose,
	onDelete

}) {


	const [thickness,setThickness]	= useState(setup.obj.thickness);
	const [color,setColor]			= useState(setup.obj.color);
	const [opacity,setOpacity]		= useState(setup.obj.opacity);
	
	const makeData = (obj) =>{
		return {...{thickness, color, opacity}, ...obj };
	}
	
	const handleClose = () => {
		
		if(onClose)
			onClose(makeData());
	}
	const handleSaveClose = () => {
		
		if(onSaveClose)
			onSaveClose(makeData());
	}
	const handleDelete = () => {
		if(onDelete)
			onDelete();
	}
	const handleChange = (data) => {
		if(onChange){
			onChange(data);
		}
	}
	
	const handleThicknessChange = (e) => {
		setThickness(e.target.value);
		
		handleChange(makeData({thickness:e.target.value}));
	}
	const handleOpacityChange = (e) => {
		setOpacity(e.target.value/100);
		
		handleChange(makeData({opacity:e.target.value/100}));
	}
	
	const handleColorChange = (val) => {
		setColor(val);
		
		handleChange(makeData({color:val}));
	}
	
	return (
		<div className="tools-panel power-roads" >
			<Row>
				<Col xs="12 title pb-2">
					<b>{handler.currentLine.properties.name}</b>
					<span onClick={handleClose} className="btn btn-close btn-sm float-end"><X size={12} /></span>
				</Col>

			
				<Col xs="12 my-3">

					<label>Thickness</label>
					<EditableRange min="1" max="20" step="1" value={setup.obj.thickness} onChange={handleThicknessChange} />
				</Col>
		
				<Col xs="12 mb-3">

					<label>Color</label>
					
					<ColorPicker onChange={handleColorChange} color={setup.obj.color} />
				</Col>
			
				<Col xs="12 mb-5">

					<label>Opacity (%)</label>
					
					<EditableRange min="1" max="100" step="1" value={setup.obj.opacity*100} onChange={handleOpacityChange} />
				</Col>
				
				<Col xs="8">
					<Button variant="primary" onClick={handleClose}>Close</Button>
				</Col>
				<Col xs="4 text-end">
					<Button className="ms-auto px-2" variant="outline-primary" onClick={handleDelete}><Trash size={16} /></Button>
				</Col>

			</Row>
		</div>	  
	);
	

}